module.exports = __webpack_public_path__ + "img/lamp-floor.3ff1b51a.svg";